<template>
<div>
  <div class="panel">
      <el-form ref="form" :model="form" :rules="formRules" label-width="130px" :disabled="allDisabled">
        <el-row style="max-height: 500px;overflow-y: auto;overflow-x: hidden;">
            <div class="dialog-group-title">基础信息</div>
            <el-col :span="12">
                  <el-form-item label="工单编号" prop="orderCode">
                      <el-input size="small" v-model="form.orderCode" placeholder="输入工单编号" disabled></el-input>
                  </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="产品编号" prop="productCode">
                    <el-input size="small" v-model="form.productCode" placeholder="输入产品编号" disabled></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="产品名称" prop="productName">
                    <el-input size="small" v-model="form.productName" placeholder="输入产品名称" disabled></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="工序编号" prop="processCode">
                    <el-input size="small" v-model="form.processCode" placeholder="输入工序编号" disabled></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="工序名称" prop="processName">
                    <el-input size="small" v-model="form.processName" placeholder="输入工序名称" disabled></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="报工权限" prop="userNameList">
                <el-select
                      size="small"
                        v-model="form.userNameList"
                        clearable
                        filterable
                        multiple
                        placeholder="请选择"
                        style="width:100%;"
                        disabled

                    >
                        <el-option
                        v-for="item in orderStatusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="报工数配比" prop="coefficient">
                    <el-input size="small" v-model="form.coefficient" placeholder="输入报工数配比" disabled></el-input>
                </el-form-item>
            </el-col>

            <el-col :span="12">
                <el-form-item label="分配列表" prop="allocateList">
                    <el-select
                      size="small"
                        v-model="form.allocateList"
                        clearable
                        filterable
                        multiple
                        placeholder="请选择"
                        style="width:100%;"
                    >
                        <el-option
                        v-for="item in userList"
                        :key="item.label"
                        :label="item.label"
                        :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="计划数" prop="planNum">
                    <el-input size="small" v-model="form.planNum" placeholder="输入计划数" disabled></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="良品数" prop="goodNum">
                    <el-input size="small" v-model="form.goodNum" placeholder="输入良品数" disabled></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="不良品数" prop="nongoodNum">
                    <el-input size="small" v-model="form.nongoodNum" placeholder="输入不良品数" disabled></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="计划开始/结束时间" prop="planTime" class="line-height-normal">
                    <el-date-picker
                    size="small"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    style="width: 100%;"
                    v-model="planTime"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="planTimeChange">
                    </el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="实际开始/结束时间" prop="actualTime"  class="line-height-normal">
                  <el-date-picker
                  size="small"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  style="width: 100%;"
                  v-model="actualTime"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="actualTimeChange" disabled>
                </el-date-picker>
                </el-form-item>
            </el-col>
          </el-row>
        <FormItem :setList="setList" :form="form" :colSpan="12" :mode="modelStatus" v-if="showChild"></FormItem>

          <!-- <el-row>
            <div class="dialog-group-title">自定义字段</div>
            <el-col :span="12">
                <el-form-item label="技术要求" prop="remark">
                    <el-input size="small" v-model="form.remark" placeholder="输入技术要求"></el-input>
                </el-form-item>
            </el-col>
          </el-row> -->
      </el-form>


  </div>
  <div class="panel-bottom">
       <el-button size="small" type="default"  @click="closeDialog">取消</el-button>
       <el-button size="small" type="primary"  @click="handleSave" v-show="modelStatus != 'view'">保存</el-button>
   </div>
</div>
</template>
<script>
import { taskSave} from '@/api/basicData';
import FormItem from "@/components/FormItem";

export default {
 name:'createMaterialList',
 components:{
    FormItem
 },
 props:{
     userData:{
       type:Object,
       default:{},
     },
     modelStatus:{
       type:String,
       default:'',
     },
     editRow:{
         type:Object,

         default:{}
     },
     userList:{
        type:Array,

        default:[]
     },
     setList:{
         type:Array,
         default:[]
     }
 },
 watch:{


     editRow:{
        handler(newVal) {
          this.showChild = true;
            if(newVal){
                this.form = JSON.parse(JSON.stringify(newVal));

                if(this.setList && this.setList != null){

                  for(let i = 0;i<this.setList.length;i++){
                    this.form[this.setList[i]['fieldName']] = this.form['taskProcess'][this.setList[i]['fieldName']];
                  }
                }
                console.log('form',this.form);
                if(this.form['planStartTime'])
                    this.planTime.push(this.form['planStartTime']);
                if(this.form['planEndTime'])
                    this.planTime.push(this.form['planEndTime']);
                if(this.form['actualStartTime'])
                    this.actualTime.push(this.form['actualStartTime']);
                if(this.form['actualEndTime'])
                    this.actualTime.push(this.form['actualEndTime']);
            }
        },
        deep: true,
        immediate: true
      }
 },
 data(){
     return{
         form:{
         },
         formRules:{
           parentId: [{
             required: true,
             message: "请选择父项产品",
             trigger: ['blur','change'],
         },] ,
         childrenId: [{
             required: true,
             message: "请选择子项产品",
             trigger: ['blur','change'],
         },] ,
         unitUsage: [{
             required: true,
             message: "请输入单位用量",
             trigger: ['blur','change'],
         },] ,
         },
          orderStatusList: [
             {
             label: "自制",
             value: "0"
             },
             {
             label: "外购",
             value: "1"
             },
             {
             label: "委外",
             value: "2"
             }
         ],
         allDisabled:false,
         planTime:[],
         actualTime:[],
         showChild:true,
     }
 },
 created(){
  if(this.modelStatus == 'view'){
    this.allDisabled = true
  }
 },
 methods:{
    planTimeChange(val){
        this.form['planStartTime'] = val[0];
        this.form['planEndTime'] = val[1];
    },
    actualTimeChange(val){
        this.form['actualStartTime'] = val[0];
        this.form['actualEndTime'] = val[1];
    },
    handleSave(){
        this.$refs.form.validate((valid) => {
            if (valid) {
            var data = JSON.parse(JSON.stringify(this.form))
            data.factoryId = this.userData.factoryId
            data.creater = this.userData.account
            taskSave(data).then(res => {
                if(res.code == 200){
                  this.$message.success('保存成功')
                  this.showChild = false,
                  this.$emit('done',{type:'save'})
                }else{
                  this.$message.error(res.msg)
                }
            }).catch(err => {
                this.$message.error(err)
            })
            }
        })
    },

    closeDialog(){
      this.showChild = false;
      this.$emit('done',{type:'cancel'})
    },
 }

}
</script>
<style>
 .panel{
     overflow-y: auto;
     overflow-x: hidden;
 }

 .panel-bottom{
     width: 100%;
     height: 40px;
     line-height: 40px;
     padding-top: 20px;
     text-align: center;
 }
 .panel-bottom el-button{
     margin: 10px 0 0 10px;
 }

</style>



// WEBPACK FOOTER //
// src/views/task/CreateLayout.vue